import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../../../Context';
import operationData from '../../../../../Operation/data.json';
import { fetchStoreStatus, updateStoreStatus } from '../../../../utils/foodDeliveryApi';
import FoodDeliveryTabs from './FoodDeliveryTabs';

const Settings = () => {
  const { institutionData } = useContext(Context);
  const institution = operationData.foodDeliveryInstitution;
  const activeInstitution = institution || institutionData?.institution || '';

  const [status, setStatus] = useState('off');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    if (!activeInstitution) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetchStoreStatus(activeInstitution);
      const s = res?.status || res?.body?.status || (res?.data?.status) || 'off';
      setStatus(s);
    } catch (err) {
      setError(err?.message || 'Failed to load store status.');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [activeInstitution]);

  const toggle = async () => {
    const next = status === 'on' ? 'off' : 'on';
    setLoading(true);
    setError('');
    try {
      await updateStoreStatus(activeInstitution, next);
      setStatus(next);
    } catch (err) {
      setError(err?.message || 'Failed to update status.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full">
      <FoodDeliveryTabs />
      <div className="px-4 py-6 lg:px-8">
        <div className="mx-auto max-w-4xl space-y-6">
        <div className="bg-white px-6 py-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-extrabold text-[#1F2937]">Food Delivery — Settings</h2>
              <p className="mt-1 text-sm text-gray-500">{activeInstitution}</p>
            </div>
          </div>

          {error && <div className="mt-3 text-sm text-red-600">{error}</div>}
          {loading && <div className="mt-3 text-sm text-gray-600">Processing...</div>}

          <div className="mt-6 flex items-center gap-4">
            <div className="font-medium">Store status:</div>
            <div className={`px-3 py-1 rounded-md ${status === 'on' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>{status.toUpperCase()}</div>
            <button onClick={toggle} className="ml-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg">Toggle</button>
          </div></div>

        </div>
      </div>
    </div>
  );
};

export default Settings;
